// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterImages45_root__2tG3M","title":"AfterImages45_title__YM_G3","images":"AfterImages45_images__2_LN2"};